import React, { forwardRef } from "react";

import { TextCTAProps } from "./TextCTA.types";
import { StyledTextCTA } from "./TextCTA.styles";
import COLORS from "../../constants/colors";
import { useGenericAsyncHandler } from "../../hooks/useGenericAsyncHandler";
const TextCTA = forwardRef<HTMLDivElement, TextCTAProps>(
    (props: TextCTAProps, ref) => {
        const {
            children,
            disabled,
            color = COLORS.BLUE,
            id,
            weight = "bold",
            iconNode,
            size = "s",
            underline,
            type = "button",
        } = props;

        const asynHandler = useGenericAsyncHandler(props?.onClick as any);

        return (
            <StyledTextCTA
                id={id}
                color={color}
                weight={weight}
                size={size}
                disabled={disabled || asynHandler?.loading}
                underline={underline}
                type={type}
                {...(props?.onClick && {
                    onClick: asynHandler?.execute,
                })}
            >
                {iconNode} {children}
            </StyledTextCTA>
        );
    },
);

export default TextCTA;
